export default function getErrorInfo(
  error: string,
  __: (key: string, ...args: (string | number)[]) => string = (key) => key
) {
  let msg = __('Failed to upload file')
  let retryable = true
  switch (error) {
    case 'LIMIT_FILE_SIZE':
      msg = __('File is too big, please make sure it is 100mb or smaller')
      retryable = false
      break
    case 'Network Error':
      msg = __('Failed to upload file due to network error')
      break
    case 'HEIC images are not supported for this upload mode.':
      msg = __('HEIC images are not supported for this account yet. Please contact support.')
      retryable = false
      break
  }

  return {
    msg,
    retryable
  }
}
